import React, {FC} from 'react';
import HLModal, {HLModalSizeType} from '../../shared/components/modal/HLModal';
import HLButton, {HLButtonStyleType} from '../../shared/components/button/HLButton';
import {deleteLessonStructureByIdFetch} from '../../app/axios/lessonFetches';

interface DeleteLessonModalProps {
    open: boolean,
    setOpen: (value: boolean) => void,
    lessonId: number | null,
    onSuccess: () => void;
}


const DeleteLessonModal: FC<DeleteLessonModalProps> = (
    {
        open,
        setOpen,
        lessonId,
        onSuccess
    }) => {

    const closeModal = () => {
        setOpen(false);
    }

    const deleteLesson = async () => {
        if (!lessonId) return
        try {
            await deleteLessonStructureByIdFetch(lessonId);
            closeModal()
            onSuccess()
        } catch (err) {
            console.error('Ошибка при удалении урока:', err);
        }
    }

    if (!lessonId) return null

    return (
        <HLModal open={open} onClose={closeModal} title="Удаление урока" sizeType={HLModalSizeType.SMALL}>
            <div className="columnContainer">
                <h3>Вы уверены что хотите удалить урок?</h3>
                <div className="inlineContainer">
                    <HLButton type="submit" onClick={deleteLesson}>Да</HLButton>
                    <HLButton type="button" onClick={closeModal} styleType={HLButtonStyleType.GRAY}>Нет</HLButton>
                </div>
            </div>
        </HLModal>
    );
};

export default DeleteLessonModal;